<template>
  <div class="step1Manager">
    <div class="title clearfix">
      <p class="type pull-left type-title">入驻类型</p>
      <el-tag class="type-tag" effect="dark" size="mini"
        :type="title === '新设' ? '' : title === '迁入' ? 'warning' : 'success'">{{ title }}</el-tag>
      <div class="type-line"></div>
      <div class="type-time">填报时间：{{ date }}</div>
    </div>
    <div style="display: flex; align-item: center; margin-bottom: 20px">
      <p class="type pull-left type-title2">入驻小镇:</p>
      <el-select v-model="tableData.ftCode" placeholder="请选择" :disabled="true">
        <el-option v-for="options in TownList" :key="options.value" :label="options.label" :value="options.value">
        </el-option>
      </el-select>
    </div>
    <table-form :dataSource="dataSource" :tableData="tableData" ref="form"></table-form>
    <div class="footerBtn">
      <el-button @click="toList">上一步</el-button>
      <el-button class="mainBtn" @click="DoDebounce(save, 'timer1')">保存</el-button>
      <el-button class="mainBtn" @click="DoDebounce(saveBeforeNext, 'timer2')">保存并下一步</el-button>
    </div>
  </div>
</template>

<script>
import TableForm from "common/components/form/tableForm";
import { newStep1, newStep2 } from "@/conf/newAgency";
import comMixin from "common/js/mixin/comMixin";
import { debounce } from 'common/js/tools.js'

import {
  getFundList,
  nation,
  selectDic,
  addUpMgr,
  getDetailMgr,
  getTownBaiscList,
} from "common/js/api";
import { mapState, mapMutations } from "vuex";

export default {
  props: ["title", "updateTitle"],

  components: {
    TableForm,
  },

  mixins: [comMixin],

  data() {
    return {
      dataSource: this.$lodash.cloneDeep(newStep1),
      route: "",
      userCode: "",
      institutionName: "",
      tableData: {},
      codeId: "",
      step: 0,
      TownList: [],
      // selectClassSta: "未选中", //默认选中
      // selectClassEnd: "未选中", //默认选中
      ftCode: "",
      date: '',
    };
  },

  created() {
    this.date = this.getDate();
    if (this.title === "新设") {
      this.dataSource = this.$lodash.cloneDeep(newStep1);
    } else if (this.title === "迁入") {
      this.dataSource = this.$lodash.cloneDeep(newStep2);
    }
    // this.userCode = "JG472449"; //
    this.userCode = this.Cookies.get("identifyCode");
    this.institutionName = this.Cookies.get("institutionName");
    this.tableData = {
      institutionName: this.institutionName,
      registeAddress: "",
    };
    let selectFtCode = this.Cookies.get("preFtCode");
    if (typeof selectFtCode != "undefined") {
      console.log("找到preFtCode", selectFtCode);
      this.tableData.ftCode = selectFtCode;
    } else {
      selectFtCode = this.Cookies.get("ftCode");
      if (typeof selectFtCode != "undefined") {
        console.log("使用ftCode", selectFtCode);
        this.tableData.ftCode = selectFtCode;
      } else console.log("preFtCode和ftCode都没有");
    }

    this.enterType = this.$route.query.flag == "new" ? 0 : 1;
  },

  mounted() {
    this.getList();
    // this.getSelect();
    this.getNation();
    this.getUpdateData();
    this.getTownList();
  },

  destroyed() {
    this.$message.closeAll();
  },

  methods: {
    getDate() {
      let year = new Date().getFullYear(); //年
      let month = new Date().getMonth() + 1; //注意！月份是从0月开始获取的，所以要+1;
      let day = new Date().getDate(); //日
      const todayDate =
        year +
        "-" +
        (month >= 10 ? month : "0" + month) +
        "-" +
        (day >= 10 ? day : "0" + day);
      return todayDate;
    },
    saveBeforeNext() {
      if (!this.tableData.ftCode || this.tableData.ftCode == "") {
        if (this.Cookies.get("ftCode")) {
          if (this.Cookies.get("ftCode") != "") {
            this.$refs.form.form.ftCode = this.Cookies.get("ftCode");
          } else {
            this.$refs.form.form.ftCode = "c2023992ae4b4bed9a8786dfc02838fc";
          }
        } else this.$refs.form.form.ftCode = "c2023992ae4b4bed9a8786dfc02838fc";
      } else this.$refs.form.form.ftCode = this.tableData.ftCode;
      this.save().then((res) => {
        if (res == true) {
          console.log("保存成功", res);
          this.$emit("next");
        } else console.log("保存失败", res);
      });

    },
    DoDebounce(func, timer) {
      debounce(func, 2000, timer, true)
    },
    setRegiste(val) {
      // const need = this.dataSource.find(
      //   (item) => item.field == "associationRegisteFinished"
      // );
      // console.log(need);
      // if (val === 1) {
      //   if (!need) {
      //     console.log(need);
      //     this.dataSource.splice(7, 0, {
      //       label: "是否完成中国证券投资基金业协会登记/备案",
      //       formtype: "select",
      //       options: [
      //         {
      //           label: "是",
      //           value: 1,
      //         },
      //         {
      //           label: "否",
      //           value: 0,
      //         },
      //       ],
      //       field: "associationRegisteFinished",
      //       require: false,
      //     });
      //   }
      // } else {
      //   if (need) {
      //     console.log(need);
      //     this.dataSource.splice(7, 1);
      //   }
      // }
    },

    async getList() {
      if (
        this.$route.query.flag == "update" ||
        this.$route.query.edit == "update"
      )
        return;
      const data = {
        userInstitutionCode: this.userCode,
        institutionType: "GL",
        page: 1,
        size: 10,
      };
      const res = await getFundList(data);
    },

    async getSelect() {
      const query = "2,4,5";
      const result = await selectDic(query);
      const { FUND_INSTITUTION_ORIGIN, FUND_PRODUCT_TYPE, INVEST_INDUSTRY } =
        result.result;

      // this.converSelect(FUND_INSTITUTION_ORIGIN, 16);
      // this.converSelect(FUND_PRODUCT_TYPE, 4);
      // this.converSelect(INVEST_INDUSTRY, 10);
    },

    async getNation() {
      const query = 0;
      const result = await nation(query);
      result.result.forEach((item) => {
        let data = {
          label: item.district,
          value: item.district,
        };
        this.dataSource[12].options.push(data); //省份
      });
    },

    async getTownList() {
      const { result } = await getTownBaiscList();
      // console.log(result);
      // if (this.title != "新设") {
      //   // this.selectClassEnd = result[0].fundTownName;
      // } else {
      //   // this.selectClassEnd = "未选中";
      result.forEach((item) => {
        let data = {
          label: item.fundTownName,
          value: item.fundTownCode,
        };
        // console.log(item);
        this.TownList.push(data);
      });
      // }
      // this.TownList = this.dataSource[12].options;
    },
    // selectClass(event) {
    //   this.$refs.form.form.ftCode = event.target.value;
    // },
    converSelect(option, index) {
      console.log("this.dataSource", this.dataSource);
      option.forEach((item) => {
        let data = {
          label: item,
          value: item,
        };
        this.dataSource[index].options.push(data);
      });
    },

    async save() {
      console.log(")-)-)-)-)-)组件自身的被掉了");
      const isValidate = this.$refs.form.submitForm();
      console.log("isValidate:", isValidate);
      if (!isValidate) return false;
      const res = await this.submit(this.$refs.form.form);
      console.log("res:", res);
      if (res == true) {
        console.log("保存成功");
        this.$message({
          message: "保存成功!",
          type: "success",
        });
        return true;
      }
    },



    async submit(form) {
      this.Cookies.set("institutionName", form.institutionName);
      this.Cookies.set("selectedBasicFtCode", this.tableData.ftCode);
      this.Cookies.set("capitalRegisted", form.capitalRegisted);

      if (this.notInAgency == true) return false;
      // form.devPlanFileOrignName = form.uploadField.oldFile;展业计划部分代码
      // form.devPlanFileStorePath = form.uploadField.newFile;
      form.userInstitutionCode = this.userCode;
      // this.Cookies.set("ftCode", this.$refs.form.form.institutionName);
      form.enterType = this.enterType;
      form.ftCode = this.tableData.ftCode;
      if (Array.isArray(form.preIndustry)) {
        form.preIndustry = form.preIndustry.join(",");
      }
      let flag = this.$route.query.edit || this.$route.query.flag;
      // 变更
      if (flag == "update") {
        form.institutionCode = this.$route.query.codeId || "";
      }
      console.log("form.institutionCode", form.institutionCode);
      console.log(
        "this.$refs.form.form.institutionCode",
        this.$refs.form.form.institutionCode
      );

      if (typeof form.institutionCode != "undefined") {
        flag = "update";
      }
      const result = await addUpMgr(flag, form);
      console.log("result", result);
      if (flag != "update") {
        this.$refs.form.form.institutionCode = result.result;
        this.$route.query.codeId = result.result;
      }

      if (this.$refs.form.form.preIndustry !== "") {
        this.$refs.form.form.preIndustry =
          this.$refs.form.form.preIndustry.split(",");
      }
      if (result.message == "EXISTED") {
        this.$message({
          message: "当前企业已经入驻,不能重复入驻!",
          type: "warning",
        });
        return false;
      }
      if (result.message == "003") {
        this.$message({
          message:
            "注册为基金管理类型入驻基金机构，入驻基金机构名称不能与注册机构名称相同!",
          type: "warning",
        });
        return false;
      }
      if (result.message == "001") {
        this.$message({
          message: "注册机构类型为基金类型不能入住基金管理机构，请入驻基金机构",
          type: "warning",
        });
        return false;
      }

      if (flag == "update") {
        this.codeId = this.$route.query.codeId;
      } else {
        this.codeId = result.result;
      }
      return true;
    },

    async getUpdateData() {
      let flag = this.$route.query.edit || this.$route.query.flag;
      const codeId = this.$route.query.codeId;

      if (flag != "update") return;
      // if (!this.mgrData[codeId] || Object.keys(this.mgrData[codeId]).length) {
      const res = await getDetailMgr(codeId);

      this.setMgrData({
        codeId: codeId,
        value: res.result,
      });
      // res.result.basic.firstPreProductScale = 1000
      this.tableData = res.result.basic;
      this.tableData.associationRegiste = this.tableData.associationRegiste
        ? "1"
        : "0";
      this.tableData.associationRegisteFinished = this.tableData
        .associationRegisteFinished
        ? "1"
        : "0";
      this.tableData.clusterRegiste = this.tableData.clusterRegiste ? "1" : "0";
      // this.selectClassSta = res.result.basic.ftCode

      if (this.tableData) {
        if (this.tableData.preIndustry !== "") {
          this.tableData.preIndustry = this.tableData.preIndustry.split(",");
        }
      }

      // 确保插入顺序不会影响下拉菜单的顺序  promise执行以后 ,在执行插入是否需要
      // setTimeout(() => {
      //   console.log(this.tableData.associationRegiste);
      //   this.setRegiste(this.tableData.associationRegiste);
      // }, 0);
      // }
    },

    toList() {
      this.$router.push("/FundManagement/FundList");
    },
    ...mapMutations(["setMgrData"]),
  },

  computed: {
    ...mapState({
      mgrData(state) {
        return state.MgrData.mgrData;
      },
    }),
  }
};
</script>

<style scoped lang="scss">
.title {
  margin: 0 0 20px 0px;
  font-size: 14px;
  color: #6c7885;
  display: flex;
  align-items: center;
}
</style>
